export default __webpack_public_path__ + "static/media/reorder.bc6827e0.svg";